import {MessageResponse} from "../models/message-response/message-response";

class ResponseMessagesService {

    constructor() {
    }

    getErrorMessage(message: MessageResponse): [title: string, message: string[]] {

        let mes: string[] = [];
        message.data?.map((v) => {
            mes.push(v)
        });

        return ["Error", mes]
    }

}


let responseMessagesService = new ResponseMessagesService();
export default responseMessagesService;